import { requestCDN } from "../../apis";

export const apiGetSetting = (params) => {
  const millis = Date.now();
  return requestCDN("get", `/setting.json?v=${millis}`);
  // return requestGlobalSettingData("get", `/setting`, params, false, false);
};
